export default __webpack_public_path__ + "static/media/icon-budgeting.0b39f766.svg";